import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePreferencePipe } from '../../../../modules/fwcore';
import { ISavedSearch, SearchService } from '../../../search/services/search.service';
import { DashboarditemComponent } from '../asklearnshare/dashboarditem/dashboarditem.component';

@Component({
  selector: 'app-search-dash',
  standalone: true,
  imports: [
    CommonModule,
    DashboarditemComponent,
    NgbPopoverModule,
    DatePreferencePipe
  ],
  templateUrl: './search-dash.component.html',
  styleUrls: ['./search-dash.component.scss']
})
export class SearchDashComponent implements OnInit {
  savedQueries: ISavedSearch[] = [];

  constructor(private route: Router, private _elementRef: ElementRef, private srchSvc: SearchService) { }

  ngOnInit(): void {

  }


  public runSearch() {
    let txtbox = this._elementRef.nativeElement.querySelector('#txtSearch');
    const searchTerm = txtbox.value;
    
    if (searchTerm != undefined && searchTerm.length > 0) {
      this.route.navigate(['/search/assistant'], { state: { searchType: 'text', searchText: searchTerm } });
    }
    else {
      this.route.navigate(['/search/assistant'], { state: { searchType: 'text', searchText: searchTerm } });
    }
  }

  public runSavedSearch(queryId: string) {
    const query = this.savedQueries.find(qry => qry.id == queryId);
    if (query != undefined) {
      this.route.navigate(['/search/assistant'], { state: { searchType: 'saved', searchText: JSON.stringify(query) } });
    }
  }
}
